import { GET_GROUP, UPDATE_GROUP, ADD_GROUP, GET_ALL_GROUP } from '../types'

const INITIAL_STATE = {
  allGroups: [],
  addGroups: [],
  updateGroups: [],
  getAllGroup: [],
  
}

const groupReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_GROUP:
      return {
        ...state,
        allGroups: payload.data,
      }
    case GET_ALL_GROUP:
      return {
        ...state,
        getAllGroup: payload.data,
      }
    case ADD_GROUP:
      return {
        ...state,
        addGroups: payload.data,
      }
    case UPDATE_GROUP:
      return {
        ...state,
        updateGroups: payload.groupId,
      }
    default:
      return state
  }
}

export default groupReducer
